import { SkeletonLine } from 'components/skeleton/Skeleton';

/**
 * The numbers at the top of a record: a tile per number, its name, its value
 * and a line under it (`tiles`: { key, label, value, detail }); a `loading`
 * tile keeps its name over grey lines the size of what is to come. A tile with an
 * entry in `actions` ({ [key]: onClick }) is a button: the record opens the
 * tab its number comes from.
 */
const TILE_CLASS = 'rounded-xl border border-gray-100 p-4 text-left';

const KpiTiles = ({ tiles, actions = {} }) => (
  <div className="grid grid-cols-1 gap-3 tab:grid-cols-3">
    {tiles.map((tile) => {
      const body = (
        <>
          <p className="text-sm font-medium text-gray-900">{tile.label}</p>
          {tile.loading ? (
            <div aria-busy="true">
              {/* The heights of the value (2rem) and of the line under it (1rem). */}
              <div className="mt-1 flex h-8 items-center">
                <SkeletonLine className="h-6 w-20" />
              </div>
              <div className="mt-1 flex h-4 items-center">
                <SkeletonLine className="h-3 w-24" />
              </div>
            </div>
          ) : (
            <>
              <p className="mt-1 text-2xl font-medium text-gray-900">{tile.value}</p>
              <p className="mt-1 text-xs text-gray-600">{tile.detail}</p>
            </>
          )}
        </>
      );
      const open = actions[tile.key];
      return open ? (
        <button
          key={tile.label}
          type="button"
          onClick={open}
          className={`${TILE_CLASS} transition-colors hover:border-gray-200 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300`}
        >
          {body}
        </button>
      ) : (
        <div key={tile.label} className={TILE_CLASS}>
          {body}
        </div>
      );
    })}
  </div>
);

export default KpiTiles;
